'use client'
import {
  Common,
  dynamic,
  HttpService,
  Messages,
  RingBuilder,
  ServiceEndpoints,
  Skeleton
} from '@/config/NextImport'
import { addToCart, getCartProducts } from '@/lib/features/cartSlice'
import { setRingBuilderReady } from '@/lib/features/ringBuilderSlice'
import { AppDispatch, AppState } from '@/lib/store'
import { usePathname, useRouter } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import KlarnaMessaging from '../KlarnaMessaging'
import { getPriceColumnFromServer } from '../../lib/priceColumn'
// import Swal from 'sweetalert2'
const ProductPrice = dynamic(() => import('@/components/common/ProductPrice'))
const WishlistIcon = dynamic(() => import('@/components/common/WishlistIcon'), {
  ssr: false,
  loading: () => {
    return (
      <img
        src={Common.setImagePath('assets/images/icon/wishlist.svg')}
        alt="wishlist-icon"
      />
    )
  }
})

const Options = ({ productDetail }: any) => {
  const router = useRouter()
  const pathname = usePathname()
  const dispatch = useDispatch<AppDispatch>()
  const { isRingBuilderReady } = useSelector((state: AppState) => state.ringBuilder)
  const [IsFirstStep, setIsFirstStep] = useState<boolean>(false)
  const [loading, setLoading] = useState(true)
  const { cartListProducts } = useSelector((state: AppState) => state.cart)
  const { userData } = useSelector((state: AppState) => state.user)
  const priceColumn = getPriceColumnFromServer()

  const [currencyData, setCurrencyData] = useState<any>([])

  useEffect(() => {
    const storageSteps: any = RingBuilder.getRingBuilder()
    const stepNo = storageSteps.filter((x: any) => x.step === 'diamond')[0].stepno
    if (stepNo === 1) setIsFirstStep(true)
    else setIsFirstStep(false)
    setLoading(false)
    const currency = JSON.parse(Common.decryptData(localStorage.getItem(Messages.Currency)))
    if (currency) {
      setCurrencyData(
        currency.filter((item: any) => item.Code === priceColumn.replace('_price', ''))
      )
    }
    // productDetail.diamond_url = window.location.href
  }, [])
  useEffect(() => {
    const storageSteps: any = RingBuilder.getRingBuilder()
    if (storageSteps[1].step === 'diamond' && storageSteps[1].IsCompleted) {
      storageSteps[1].product.formated_price = productDetail.formated_price
    }
    RingBuilder.setRingBuilder(storageSteps)
    dispatch(setRingBuilderReady(!isRingBuilderReady))
  }, [productDetail])

  const addProductToCart = async () => {
    await dispatch(
      addToCart({ item: productDetail, ringSizeId: '', user: userData.user, country: '' })
    )
    await dispatch(getCartProducts())
    router.push('/cart')
  }

  const nextStepDetails = async (isFirst = true) => {
    let categories = productDetail.category_ids.split(',')
    let isDiamond = 1
    if (!isFirst) {
      const storageSteps: any = RingBuilder.getRingBuilder()
      categories = storageSteps[0].product.category_ids.split(',')
      isDiamond = storageSteps[0].step === 'diamond' ? 1 : 0
    }
    const param = {
      category_ids: categories.join(',').replace(/^,|,$/g, ''),
      is_diamond: isDiamond
      // setting_default_shape: productDetail.defaultShape
    }
    return new Promise((resolve) => {
      HttpService.postApi(ServiceEndpoints.getSecondStepUrl, param).then((response) => {
        try {
          resolve(response.result[0])
        } catch (error) {
          console.log(error)
        }
      })
    })
  }

  const proceedToNextStep = async (e: any) => {
    e.preventDefault()
    const Swal = (await import('sweetalert2')).default
    const storageSteps: any = RingBuilder.getRingBuilder()
    const detailPath =
      productDetail.name.replaceAll(' ', '-').toLowerCase() + '-sku-' + productDetail.sku
    const productData = {
      category_ids: productDetail.category_ids,
      name: productDetail.name,
      price: productDetail.price,
      special_price: productDetail.special_price,
      formated_special_price: productDetail.formated_special_price,
      formated_price: productDetail.formated_price,
      image: productDetail.base_image,
      default_image: productDetail.default_image,
      attribute_options: productDetail.attribute_options,
      is_sold: productDetail.is_sold,
      is_diamond: productDetail.is_diamond,
      is_gemstone: productDetail.is_gemstone
    }
    if (storageSteps === undefined || storageSteps[0].IsCompleted === false) {
      // 1st Step is Diamond
      const slug = pathname.split('/')
      const finalUrl = pathname?.includes('-sku-')
        ? `${slug.slice(0, slug.length - 1).join('/')}`
        : pathname

      const responseData: any = await nextStepDetails()
      storageSteps[0].selected_productid = productDetail.sku
      storageSteps[0].product = productData
      storageSteps[0].IsCompleted = true
      storageSteps[0].detail_url = pathname
      storageSteps[0].url = finalUrl
      storageSteps[0].IsActive = false
      storageSteps[1].IsActive = true
      RingBuilder.setRingBuilder(storageSteps)
      const caratRange = JSON.parse(productData.attribute_options).filter(
        (x: any) => x.title === 'Carat'
      )[0]
      if (caratRange) {
        router.push(responseData[0].setting_url + `&carat=${caratRange?.value}`)
      } else {
        router.push(responseData[0].setting_url)
      }
    } else if (storageSteps[0].IsCompleted === true && storageSteps[1].IsCompleted === true) {
      // when both steps get completed and user change it from review step
      const sSku = storageSteps.filter((x: any) => x.step === 'setting')[0].selected_productid
      // const dSku = storageSteps.filter((x) => x.step === 'diamond')[0].selected_productid
      const dSku = productDetail.sku
      const stepIndex = storageSteps.findIndex((item: any) => item.step === 'diamond')
      storageSteps[stepIndex].selected_productid = productDetail.sku
      storageSteps[stepIndex].product = productData
      storageSteps[0].IsActive = false
      storageSteps[1].IsActive = false
      storageSteps[2].IsActive = true
      storageSteps[2].url = '/complete-jewel?j=' + dSku + '&s=' + sSku
      RingBuilder.setRingBuilder(storageSteps)
      router.replace(`/complete-jewel?j=${dSku}&s=${sSku}`)
    } else if (storageSteps[0].IsCompleted === true) {
      if (storageSteps[0].step === 'diamond') {
        // when user comes from the 2nd step without completing the ring builder
        const responseData: any = await nextStepDetails()
        const productData = {
          category_ids: productDetail.category_ids,
          name: productDetail.name,
          price: productDetail.price,
          special_price: productDetail.special_price,
          formated_special_price: productDetail.formated_special_price,
          formated_price: productDetail.formated_price,
          image: productDetail.base_image,
          default_image: productDetail.default_image,
          attribute_options: productDetail.attribute_options,
          is_diamond: productDetail.is_diamond,
          is_gemstone: productDetail.is_gemstone
        }
        storageSteps[0].selected_productid = productDetail.sku
        storageSteps[0].product = productData
        storageSteps[0].IsCompleted = true
        storageSteps[0].detail_url = pathname
        RingBuilder.setRingBuilder(storageSteps)
        const caratRange = JSON.parse(productData.attribute_options).filter(
          (x: any) => x.title === 'Carat'
        )[0]
        if (caratRange) {
          router.push(responseData[0].setting_url + `&carat=${caratRange?.value}`)
        } else {
          router.push(responseData[0].setting_url)
        }
      } else {
        // when 1st completed (diamond) and 2nd step is setting in ring builder
        const responseData: any = await nextStepDetails(false)
        const settingData = storageSteps.filter((x: any) => x.step === 'setting')[0]

        const canBeSet =
          settingData.product.can_be_set_with !== '' && settingData.product.can_be_set_with !== null
            ? Common.GetJSON(settingData.product.can_be_set_with)
            : []
        if (canBeSet !== null) {
          const diamondShape = Common.GetJSON(productDetail.attribute_options).filter(
            (x: any) => x.title.toLowerCase() === 'shape'
          )[0].value
          const diamondCarat = Common.GetJSON(productDetail.attribute_options).filter(
            (x: any) => x.title.toLowerCase() === 'carat'
          )[0].value
          const checkShape = canBeSet.filter(
            (x: any) =>
              x.shape.toLowerCase() === diamondShape.toLowerCase() &&
              parseFloat(x.carat_from) <= parseFloat(diamondCarat) &&
              parseFloat(diamondCarat) <= parseFloat(x.carat_to)
          )
          if (checkShape.length > 0) {
            const productData = {
              category_ids: productDetail.category_ids,
              name: productDetail.name,
              price: productDetail.price,
              special_price: productDetail.special_price,
              formated_special_price: productDetail.formated_special_price,
              formated_price: productDetail.formated_price,
              image: productDetail.base_image,
              default_image: productDetail.default_image,
              attribute_options: productDetail.attribute_options,
              is_diamond: productDetail.is_diamond,
              is_gemstone: productDetail.is_gemstone
            }
            storageSteps[0].selected_standalone_options =
              settingData.product.selected_standalone_options
            storageSteps[1].selected_productid = productDetail.sku
            storageSteps[1].product = productData
            storageSteps[1].IsCompleted = true
            storageSteps[1].IsActive = false
            storageSteps[2].IsActive = true
            storageSteps[1].IsGemstone = productDetail.is_gemstone
            storageSteps[1].detail_url =
              (productDetail.is_gemstone
                ? responseData.gemstone_url
                : responseData.diamond_url.split('?')[0]) +
              '/' +
              detailPath
            if (storageSteps[1].url !== '')
              storageSteps[1].url = productDetail.is_gemstone
                ? responseData.gemstone_url
                : responseData.diamond_url
            const diamondSku = productDetail.sku
            const settingSku = storageSteps.filter((x: any) => x.step === 'setting')[0]
              .selected_productid
            storageSteps[2].url = '/complete-jewel?j=' + productDetail.sku + '&s=' + settingSku
            RingBuilder.setRingBuilder(storageSteps)
            router.replace(`/complete-jewel?j=${diamondSku}&s=${settingSku}`)
          } else {
            const isGemstone = productDetail.is_gemstone
            Swal.fire({
              title: Messages.diamond_not_compatible,
              text: isGemstone
                ? Messages.GemstoneRingBuilderShapeNotMatch
                : Messages.RingBuilderShapeNotMatch
            })
          }
        } else {
          const isGemstone = productDetail.is_gemstone
          Swal.fire({
            title: Messages.diamond_not_compatible,
            text: isGemstone
              ? Messages.GemstoneRingBuilderShapeNotMatch
              : Messages.RingBuilderShapeNotMatch
          })
        }
      }
    } else {
      const responseData: any = await nextStepDetails()
      const productData = {
        category_ids: productDetail.category_ids,
        name: productDetail.name,
        price: productDetail.price,
        special_price: productDetail.special_price,
        formated_special_price: productDetail.formated_special_price,
        formated_price: productDetail.formated_price,
        image: productDetail.base_image,
        default_image: productDetail.default_image,
        attribute_options: productDetail.attribute_options,
        is_diamond: productDetail.is_diamond,
        is_gemstone: productDetail.is_gemstone
      }
      RingBuilder.removeRingBuilder()
      RingBuilder.setDiamondBuilder(
        productDetail.is_gemstone
          ? responseData.gemstone_url
          : responseData.diamond_url.split('?')[0],
        productDetail.is_gemstone
      )
      const storageSteps: any = RingBuilder.getRingBuilder()
      storageSteps[0].selected_productid = productDetail.sku
      storageSteps[0].product = productData
      storageSteps[0].IsCompleted = true
      storageSteps[0].detail_url =
        (productDetail.is_gemstone
          ? responseData.gemstone_url
          : responseData.diamond_url.split('?')[0]) +
        '/' +
        detailPath
      RingBuilder.setRingBuilder(storageSteps)
      router.push(responseData.setting_url.split('?')[0])
    }
  }

  return (
    <div className="product-summary-bottom">
      {productDetail.is_sold ? <h3 className="not-available-title">Not Available</h3> : ''}
      {!productDetail.is_sold && (
        <div className="product-summary-price">
          <span>
            <ProductPrice data={productDetail} />{' '}
            <small>({productDetail.is_gemstone ? 'Gemstone Price' : 'Diamond Price'})</small>
          </span>
        </div>
      )}

      <div className="product-summary-btn">
        {loading ? (
          <div style={{ marginRight: '8px' }}>
            <Skeleton
              highlightColor={'#f1ebee'}
              width={250}
              height={42}
              baseColor={'#f1f1f1'}
            />
          </div>
        ) : (
          <>
            {IsFirstStep && !productDetail.is_sold && (
              <button
                className="btn btn-custom"
                onClick={() => addProductToCart()}
              >
                {cartListProducts?.products?.some(
                  (x: any) => x.diamond_sku === productDetail.sku
                ) ? (
                  <>Update Your Cart</>
                ) : (
                  <>Add To Cart</>
                )}
              </button>
            )}
            {!productDetail.is_sold && (
              <button
                className="btn btn-custom"
                onClick={(e) => proceedToNextStep(e)}
              >
                {IsFirstStep === true
                  ? 'Add a Setting'
                  : productDetail.is_gemstone
                    ? 'Choose this gemstone'
                    : 'Choose this diamond'}
              </button>
            )}
          </>
        )}

        <button className="btn wishlist-btn">
          <WishlistIcon item={productDetail} />
        </button>
        <button
          className="btn message-btn btn-custom-light"
          data-bs-toggle="modal"
          data-bs-target="#DropHintModal"
          data-backdrop="static"
          data-keyboard="false"
        >
          <img
            width={30}
            src={Common.setImagePath('assets/images/icon/drop-hint-icon.svg')}
            alt="Drop A Hint"
          />
        </button>
      </div>
      {currencyData.length > 0 && !productDetail.is_sold && (
        <KlarnaMessaging
          amount={parseFloat(productDetail[priceColumn]) * 100}
          currency={currencyData.length > 0 ? currencyData[0].currency_name : 'GBP'}
          countryCode={currencyData.length > 0 ? currencyData[0].Code : 'GB'}
        />
      )}
    </div>
  )
}

export default Options
